import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import Configurator from '../Screens/Configurator';
import customConfigurator from '../Reducers/Configurator/Reducer';
import ConfiguratorService from '../Services/ConfiguratorService';
import InteractionService from '../Services/InteractionService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://localhost:10690',
  local: 'http://int.rau.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator,
    ItemOverview: Configurator
  },
  reducers: {
    configurator: customConfigurator,
  },
  services: {
    ConfiguratorService,
    InteractionService
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
